module.exports = __webpack_public_path__ + "static/media/Slide2.0a9c9d9d.png";


//////////////////
// WEBPACK FOOTER
// ./src/Assets/v2/home/Slide2.png
// module id = 571
// module chunks = 4